import Dragula from 'dragula';

global.dragula = Dragula;